module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('navigator', {
    attrs: {
      "selectedProduct": _vm.getSelectedItem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexGrow1",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c(_vm.stepTemplate, {
    tag: "component",
    attrs: {
      "currentStep": _vm.currentStep
    },
    on: {
      "cancelling": _vm.cancel,
      "goToStep": _vm.goToStep,
      "readyToSave": _vm.save,
      "updateBackupGroup": _vm.updateBackupGroup
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0279e5b4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0279e5b4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductForm.vue
// module id = 1938
// module chunks = 0